import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): PurchaseState => {
  return {
    paymentPlans: [],
    paymentError: null,
    paymentPlanLoadingError: null,
    stripeCoupon: null,
    couponCodeErrorText: null,
    couponCodeSuccessText: null,
    referralCodeErrorText: null,
    referralCodeSuccessText: null,
  };
};

const purchase = (
  state = getInitialState(),
  action: ActionTypes
): PurchaseState => {
  switch (action.type) {
    case TypeKeys.SET_STRIPE_COUPON: {
      return {
        ...state,
        stripeCoupon: action.code,
      };
    }
    case TypeKeys.SET_COUPON_CODE_ERROR: {
      return {
        ...state,
        couponCodeErrorText: action.message,
      };
    }
    case TypeKeys.SET_COUPON_CODE_SUCCESS: {
      return {
        ...state,
        couponCodeSuccessText: action.message,
      };
    }
    case TypeKeys.SET_REFERRAL_CODE_ERROR: {
      return {
        ...state,
        referralCodeErrorText: action.message,
      };
    }
    case TypeKeys.SET_REFERRAL_CODE_SUCCESS: {
      return {
        ...state,
        referralCodeSuccessText: action.message,
      };
    }
    case TypeKeys.SET_PAYMENT_PLANS: {
      return {
        ...state,
        paymentPlans: action.paymentPlans,
      };
    }
    case TypeKeys.SET_PAYMENT_ERROR: {
      return {
        ...state,
        paymentError: action.message,
      };
    }
    case TypeKeys.SET_PAYMENT_PLAN_LOADING_ERROR: {
      return {
        ...state,
        paymentPlanLoadingError: action.message,
      };
    }
  }
  return state;
};

export default purchase;
